import { useMemo } from "react";

type Chat = {
  id: string;
  name: string;
  created: Date;
  updated: Date;
  messages: { id: number; sender: string; content: string }[];
};

const useGroupedChats = (chats: Chat[]) => {
  return useMemo(() => {
    const categories: { [key: string]: Chat[] } = {};

    const sortedChats = [...chats].sort(
      (a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime()
    );

    sortedChats.forEach((chat) => {
      const updated = new Date(chat.updated);
      const month = updated.toLocaleString("th-TH", { month: "long" });
      const year = updated.getFullYear();
      const category = `${month} ${year}`;

      if (!categories[category]) categories[category] = [];
      categories[category].push(chat);
    });

    return categories;
  }, [chats]);
};

export default useGroupedChats;
